(() => {
  const form = document.querySelector('[data-siti-newsletter-form] ._form_1');
  if (!form) return;

  const embedUrl = 'https://kinamics.activehosted.com/f/embed.php?id=1';
  let requested = false;
  let observer;

  const loadForm = () => {
    if (requested) return;
    requested = true;
    observer?.disconnect();
    if (document.querySelector('script[src="' + embedUrl + '"]')) return;

    const script = document.createElement('script');
    script.src = embedUrl;
    script.charset = 'utf-8';
    script.async = true;
    form.after(script);
  };

  if (window.location.hash === '#sit-i-newsletter') loadForm();
  document.addEventListener('click', (event) => {
    if (event.target.closest('a[href$="#sit-i-newsletter"]')) loadForm();
  });

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) loadForm();
    }, { rootMargin: '600px 0px' });
    observer.observe(form);
  } else {
    loadForm();
  }
})();
